module.exports = __webpack_public_path__ + "img/02-6.87c2ca7b.png";